import clsx from 'clsx'
import {PageTitle, ToolbarType, useLayout} from '../../core'
import {Toolbar} from './Toolbar'
import {PageTitleWrapper} from './page-title'
import {Link, useLocation, useSearchParams, useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'
import Tabs, {Tab} from 'react-best-tabs'
import 'react-best-tabs/dist/index.css'
import {Company} from '../../../../app/modules/profile/components/Company'
// import { Billing } from '../../../../app/modules/profile/components/Billing'
import {Team} from '../../../../app/modules/profile/components/Team'
import {EmailIntegration} from '../../../../app/modules/profile/components/EmailIntegration'
import {TransactionalEmailIntegration} from '../../../../app/modules/profile/components/TransactionalEmailIntegration'
import {BCCTracking} from '../../../../app/modules/profile/components/BCCTracking'
import {Locale} from '../../../../app/modules/profile/components/Locale'
import {NotificationPreferences} from '../../../../app/modules/profile/components/NotificationPreferences'
import {Referral} from '../../../../app/modules/profile/components/Referral'

import {
  EmailPreferencesOutput,
  companyInitialValues,
  localeInitialValues,
  profileBreadCrumbs,
  userInitialValues,
  postmarkInitialValues,
  initialValues,
  customSmtpInitialValues,
  senderInitialValues,
  nylasGoogleInitialValues,
  nylasMicrosoftInitialValues,
  errorMessage,
} from '../../../../app/modules/profile/core/_constants'
import {useEffect, useState} from 'react'

import './styles/sidebar.scss'

import {useAuth} from '../../../../app/modules/auth'
import {
  companyData,
  getEmailPreferences,
  getLocale,
  getReferralData,
  getTotalReferralEarning,
  profileData,
  getBccTrackingData,
  getUserList,
  getMailInfo,
  getPendingUsers,
  connectNylas,
} from '../../../../app/modules/profile/core/_requests'
import {toast} from 'react-toastify'
import {CountryModel} from '../../../../app/modules/onboarding'
import {getCountry, state} from '../../../../app/modules/onboarding/core/_requests'
import {getCompanyMetaIdType} from '../../../../app/modules/profile/core/_models'
import {useInvestorDatabase} from '../../../../app/modules/investor-database/core/InvestorContext'
import {Filter} from '../../../../app/modules/widgets/components/General/Filter'
import useGetBillingData from '../../../../app/hooks/useGetBillingData'
import {useThemeMode} from '../../../partials'
import {roleValues} from '../../../../app/core/_constants'
// import ResourceOverview from '../../../../app/modules/resources/components/ResourceOverview'
// import {FounderMarketOverview} from '../../../../app/modules/founder-market/components/FounderMarketOverview'
import NoDataPage from '../../../../app/modules/widgets/components/NoDataPage'
import {Contacts} from '../../../../app/modules/shared-access/view/contacts'
import {Inbox} from '../../../../app/modules/shared-access/view/inbox'
import Calendar from '../../../../app/modules/shared-access/view/calendar'
// import RectangularTabs from '../../../../app/modules/widgets/components/RectangularTabs'
import '../../../../app/modules/widgets/components/styles/rectangularTabs.scss'
import VerticalTabs from '../../../../app/modules/widgets/components/VerticalTabs'
import RectangularTabs from '../../../../app/modules/widgets/components/RectangularTabs'
import {useModuleStatus} from '../../../../app/hooks/useModuleStatus'
import {EarlyAccessInvite} from '../../../../app/modules/dashboard/views/EarlyAccessInvite'
import ActivateSubscription from '../../../../app/modules/dashboard/views/ActivateSubscription'

const ToolbarWrapper = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const searchParam = new URLSearchParams(location.search)
  const tabs = searchParam.get('tabs')
  const {formatMessage} = useIntl()
  const {config, classes} = useLayout()
  const [key, setKey] = useState(1)
  const {mode} = useThemeMode()
  const [connectedAccount, setconnectedAccount] = useState('') // eslint-disable-line
  const isRkAppReady = process.env.REACT_APP_RK_APP_IS_READY === 'true'
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'
  const {companyQueuePosition, planStatus} = useAuth()

  const tabMapping: {[key: string]: number} = {
    'my-resources-downloads': 2,
    'claimed-market-deals': 2,
    company: 2,
    billing: 3,
    team: 4,
    integration: 5,
    'bcc-tracking': 6,
    locale: 7,
    'notification-preferences': 8,
    referral: 9,
    default: 1,
  }

  const initialKey = (tabs: string | null, defaultKey: number) => {
    return tabs && tabMapping[tabs] ? tabMapping[tabs] : defaultKey
  }

  const [settingsKey, setSettingsKey] = useState(initialKey(tabs, 1))

  const handleTabClick = (event: any, tab: number, path: string) => {
    event.preventDefault()
    if (path === 'settings') {
      setSettingsKey(tab)
      const settingsTabMapping: {[key: number]: string} = {
        2: 'company',
        3: 'billing',
        4: 'team',
        5: 'integration',
        6: 'bcc-tracking',
        7: 'locale',
        8: 'notification-preferences',
        9: 'referral',
        1: 'user',
      }
      navigate(`?tabs=${settingsTabMapping[tab]}`)
    }
  }

  useEffect(() => {
    const updateStateAndURL = (
      path: string,
      keySetter: (key: number) => void,
      defaultTab: string
    ) => {
      if (location.pathname === path) {
        keySetter(initialKey(tabs, 1))
        if (!tabs || !tabMapping[tabs]) {
          searchParam.set('tabs', defaultTab)
          navigate(
            {
              pathname: location.pathname,
              search: searchParam.toString(),
            },
            {replace: true}
          )
        }
      }
    }

    updateStateAndURL('/settings', setSettingsKey, 'user')
  }, [location.pathname, location.search, tabs, navigate]) // eslint-disable-line react-hooks/exhaustive-deps

  const {
    currentUser,
    setisShowDemoDashboard,
    setisShowHelpBanners,
    setCurrentUser,
    companyId,
    setCurrentState,
    selected, // eslint-disable-line
    setSelected,
    setCurrencyBill,
    billingData,
    setBillingData,
    setShowBillingModal,
    role,
    setEntitlements,
    setCompanyCurrency,
  } = useAuth()
  const [, setApiLoading] = useState(false)
  const [, setImgName] = useState<string>()
  const [companyImgName, setCompanyImgName] = useState<string>()
  const [getCompanyApiLoading, setGetCompanyApiLoading] = useState(false)
  const [getLocaleApiLoading, setGetLocaleApiLoading] = useState(false)
  const [getPreferencesApiLoading, setGetPreferencesApiLoading] = useState(false)
  const [countryId, setCountryId] = useState<string | undefined>()
  const [countryOptions, setcountryOptions] = useState<any[]>([])
  const [stateOptions, setstateOptions] = useState<any[]>([])
  const [getPreferences, setGetPreferences] = useState(EmailPreferencesOutput)
  const {
    searchValue,
    storeSearchValue,
    setInvestorDbFilter,
    sort_by_investorDb,
    sort_order_investorDb,

    storeSearchInvestorUpdate,
    storeSearchPitchDeck,
    setInvestorUpdateFilter,
    investorUpdateStatusFilter,

    setPitchDeckFilter,
    pitchDeckStatusFilter,
    setTemplateFilter,
    templateStatusFilter,
    storeSearchTemplate,
    setEmailFilter,
    emailStatusFilter,
    storeSearchEmail,
    selectedContextTargetValue,
    selectedStageContextFocusValue,
    selectedTargetContextLocationValue,
    selectedTargetContextGeographiesValue,
    selectedTargetContextInvestorTypeValue,
  } = useInvestorDatabase()

  const [investorCrmFilter, setInvestorCrmFilter] = useState<boolean>(false) // eslint-disable-line

  const sidebarOptions = ['Email', 'Calendar', 'APIs']
  const [sidebar, setSidebar] = useState(1)
  const emailOptions = ['Promotional Email', 'Transactional Email']
  const [subbar, setSubbar] = useState(1)
  const options = [
    {
      id: 1,
      title: formatMessage({id: 'Inbox'}),
      subTitle: formatMessage({id: 'Shared Inbox for Team'}),
      slug: 'inbox',
    },
    {
      id: 2,
      title: formatMessage({id: 'Calendar'}),
      subTitle: formatMessage({id: 'Shared Inbox for Team'}),
      slug: 'calendar',
    },
    {
      id: 3,
      title: formatMessage({id: 'Contacts'}),
      subTitle: formatMessage({id: 'Shared Inbox for Team'}),
      slug: 'contacts',
    },
  ]

  const [bccEmail, setBccEmail] = useState('')
  const [emailSignature, setEmailSignature] = useState('')
  const [nylasEmailSignature, setNylasEmailSignature] = useState('')

  const [userList, setUserList] = useState<any[]>([])
  const [pendingUsersList, setPendingUsersList] = useState<any[]>([])

  const [referral, setReferral] = useState<string>()
  const [paypalId, setPaypalId] = useState<string>()
  const [totalEarning, setTotalEarning] = useState<string>()
  const [totalReferred, setTotalReferred] = useState<string>()

  const [postmarkRadio, setPostmarkRadio] = useState(false)
  const [sendgridRadio, setSendgridRadio] = useState(false)
  const [foundercrateRadio, setFoundercrate] = useState(false)
  const [customsmtpRadio, setCustomSmtpRadio] = useState(false)

  const [nylasGoogleRadio, setNylasGoogleRadio] = useState(false)
  const [nylasMicrosoftRadio, setNylasMicrosoftRadio] = useState(false)

  const {getBillingDetailsAPI, onAccessBillingPortal} = useGetBillingData(companyId!) // eslint-disable-line

  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const {moduleStatus} = useModuleStatus()
  useEffect(() => {
    if (tab === 'calendar') {
      setSelectedTab(2)
    } else if (tab === 'contacts') {
      setSelectedTab(3)
    } else if (tab === 'inbox') {
      setSelectedTab(1)
    }
  }, [tab])
  // const handleTabChange = (index: number) => {
  //   setTab(index + 1)
  //   navigate(`${location.pathname}?tab=${options[index].title.toLowerCase()}`)
  // }

  // shared access

  const filteredOptions =
    moduleStatus['shared-access'] !== false
      ? options
      : options.filter((option) => ![2].includes(option.id))

  // State for managing the selected tab
  const [selectedTab, setSelectedTab] = useState<number>(filteredOptions[0]?.id || 1)

  // Handle tab change
  const handleTabChange = (id: number) => {
    setSelectedTab(id)
    const selectedOption = options.find((option) => option.id === id)
    if (selectedOption) {
      navigate(`${location.pathname}?tab=${selectedOption.slug.toLowerCase()}`)
    }
  }

  // useEffect(() => {
  //   const handleTabChange = () => {
  //     navigate(`${location.pathname}?tab=${options[0].slug}`)
  //   }
  //   handleTabChange() // eslint-disable-next-line
  // }, [])

  // api calling starts

  //Billing API Call

  useEffect(() => {
    const plan: any = billingData?.subscription_items[0].item_price_id?.split('-')
    if (plan) {
      setSelected(plan[0])
      setCurrencyBill(plan[1])
      setCompanyCurrency(currentUser?.company[0]?.currency?.code)
      setCurrentState(plan[2])
    }
  }, [billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getBillingDetails = async () => {
      const result = await getBillingDetailsAPI()
      setBillingData({...result.output, transaction_id: result.current_plan_invoice_id})
      setEntitlements(result.entitlement_list as any[])
    }
    if (companyId) {
      getBillingDetails()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  //Referral API Calls
  const getReferral = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getReferralData()
      if (success) {
        setReferral(data.referCode)
        setPaypalId(data.paypalEmail)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const totalReferralEarning = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getTotalReferralEarning()
      if (success) {
        setTotalEarning(data.earnings)
        setTotalReferred(data.totalReferred)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getReferral()
    totalReferralEarning()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getProfileInfo = async () => {
      try {
        if (companyId) {
          setApiLoading(true)
          const {
            data: {success, data, errors},
          } = await profileData(companyId)
          if (success) {
            setApiLoading(false)
            setImgName(data.profileImage)
            setisShowHelpBanners(data.showHelpBanners === 1 ? true : false)
            setCurrentUser({
              ...currentUser,
              firstName: data.firstName,
              profileImg: data.profileImage,
            })
            const communicationData = JSON.parse(data.communication)
            userInitialValues.firstName = data.firstName
            userInitialValues.lastName = data.lastName
            userInitialValues.email = data.email
            userInitialValues.contactNumber = data.contact!
            userInitialValues.country = data.countryId!
            userInitialValues.designation = data.designation
            userInitialValues.profileImageId = data.profileImageId!
            userInitialValues.communication.email = communicationData?.email || false
            userInitialValues.communication.phone = communicationData?.phone || false
          } else if (errors) {
            setApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        setApiLoading(false)
        console.log(err)
      }
    }
    getProfileInfo()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getCompanyData = async () => {
      try {
        setGetCompanyApiLoading(true)
        if (companyId) {
          const {
            data: {success, data, errors},
          } = await companyData(companyId)
          if (success) {
            setGetCompanyApiLoading(false)
            setCompanyImgName(data?.file?.name)
            setisShowDemoDashboard(data.showDemoDashboard === 1 ? true : false)
            companyInitialValues.companyName = data.name
            companyInitialValues.tagline = data.tagline
            companyInitialValues.teamSize = data.teamSize
            companyInitialValues.legalName = data.legalName
            companyInitialValues.operatingStatus = data.operatingStatus
            companyInitialValues.currencyId = data.currencyId
            companyInitialValues.shortDescription = data.shortDescription
            companyInitialValues.description = data.description
            companyInitialValues.foundedDate = data.foundedDate
            companyInitialValues.industry = data.industry
            companyInitialValues.country = data.countryId
            companyInitialValues.state = data.stateId
            companyInitialValues.founders = data.founders
            companyInitialValues.logoId = data.logoId
            companyInitialValues.socialMedia.website = data.website
            companyInitialValues.socialMedia.facebook = data.facebook
            companyInitialValues.socialMedia.twitter = data.twitter
            companyInitialValues.socialMedia.linkedin = data.linkedin
            companyInitialValues.socialMedia.instagram = data.instagram
          } else {
            setGetCompanyApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        setApiLoading(false)
        console.log(err)
      }
    }
    // if (companyId && (role === roleValues.OWNER || role === roleValues.ADMIN)) {
    if (companyId && role === roleValues.OWNER) {
      getCompanyData()
    }
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchCountry = async () => {
      const {
        data: {data: countries},
      } = await getCountry()
      const countriesData = countries.map((country: CountryModel) => {
        return {
          id: country.countryId,
          name: country.country_name,
          value: country.countryId,
        }
      })
      setcountryOptions([...countriesData])
    }
    fetchCountry()
  }, [])

  useEffect(() => {
    const fetchState = async () => {
      try {
        if (!countryId) {
          return
        }
        const {
          data: {data: states, success},
        } = await state(countryId!)
        if (success) {
          const stateData = states.map((state: any) => {
            return {
              id: state.stateId,
              name: state.state_name,
              value: state.stateId,
            }
          })
          setstateOptions([...stateData])
        }
      } catch (err) {
        console.log(err)
      }
    }
    fetchState()
  }, [countryId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getCompanyMeta = async () => {
      try {
        if (companyId) {
          setGetLocaleApiLoading(true)
          const {
            data: {success, data, errors},
          } = await getLocale()
          if (success) {
            setGetLocaleApiLoading(false)
            data.map(({key, value}: getCompanyMetaIdType) => {
              return (localeInitialValues[key] = value)
            })
            return null
          } else {
            setGetLocaleApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        setGetLocaleApiLoading(false)
        console.log(err)
      }
    }
    getCompanyMeta()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getApiEmailPreferences = async () => {
      try {
        if (companyId) {
          setGetPreferencesApiLoading(true)
          const {
            data: {
              data: {preference},
              success,
              errors,
            },
          } = await getEmailPreferences(companyId)
          if (success) {
            setGetPreferencesApiLoading(false)
            setGetPreferences(JSON.parse(preference))
          } else {
            setGetPreferencesApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        setGetPreferencesApiLoading(false)
        console.log(err)
      }
    }
    getApiEmailPreferences()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  //for bcctracking
  useEffect(() => {
    const getBcctrackingData = async () => {
      try {
        if (companyId) {
          const {
            data: {success, data, errors},
          } = await getBccTrackingData(companyId)
          if (success) {
            setBccEmail(data.email)
          } else {
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    getBcctrackingData()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const connectToNylas = async (provider: string) => {
      if (searchParams.has('code')) {
        const code = searchParams.get('code')

        try {
          const {
            data: {success, errors},
          } = await connectNylas(code, companyId, provider)
          if (success) {
            toast.success(formatMessage({id: 'Mailer updated successfully'}), {
              autoClose: 2000, // Toast will close after 2 seconds
              onClose: () => {
                searchParams.delete('code')
                setSearchParams(searchParams, {replace: true})
                document.location.reload() // Reload the page when the toast closes
              },
            })
          } else {
            searchParams.delete('code')
            setSearchParams(searchParams, {replace: true})
            errors.forEach((error: string) => {
              if (
                error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
                error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
              ) {
                setShowBillingModal(true)
                toast.error(formatMessage({id: error}), {autoClose: false})
              } else {
                toast.error(formatMessage({id: error}))
              }
            })
          }
        } catch (err) {
          console.log(err)
        }
      } else if (searchParams.has('error')) {
        toast.error(
          searchParams.get('error_description') || 'There was an error! Please try again.'
        )
      }
    }

    const provider = localStorage.getItem('NYLAS_PROVIDER')
    if (provider) {
      connectToNylas(provider)
      localStorage.removeItem('NYLAS_PROVIDER')
    }
  }, [companyId, formatMessage, searchParams, setSearchParams]) // eslint-disable-line react-hooks/exhaustive-deps

  // Email Integration API
  const getMailInformation = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getMailInfo(companyId)
      if (success) {
        senderInitialValues.fromName = data.fromName
        senderInitialValues.fromEmail = data.fromAddress
        senderInitialValues.replyToName = data.replyToName
        senderInitialValues.replyToEmail = data.replyToAddress
        senderInitialValues.nylasFromName = data.nylasFromName
        senderInitialValues.nylasFromEmail = data.nylasFromAddress
        senderInitialValues.nylasReplyToName = data.nylasReplyToName
        senderInitialValues.nylasReplyToEmail = data.nylasReplyToAddress
        setEmailSignature(data.emailSignature)
        setNylasEmailSignature(data.nylasEmailSignature)
        if (data.sendgrid !== null) {
          initialValues.apiKey = data.sendgrid.apiKey
        }
        if (data.smtp !== null) {
          customSmtpInitialValues.username = data.smtp.username
          customSmtpInitialValues.encryption = data.smtp.encryption
          customSmtpInitialValues.password = data.smtp.password
          customSmtpInitialValues.server = data.smtp.server
          customSmtpInitialValues.port = data.smtp.port
        }
        if (data.postmark !== null) {
          postmarkInitialValues.serverToken = data.postmark.serverToken
        }
        if (data.isActive === 'postmark') {
          setPostmarkRadio(true)
          setSendgridRadio(false)
          setCustomSmtpRadio(false)
          setFoundercrate(false)
        } else if (data.isActive === 'sendgrid') {
          setPostmarkRadio(false)
          setSendgridRadio(true)
          setCustomSmtpRadio(false)
          setFoundercrate(false)
        } else if (data.isActive === 'foundercrate') {
          setPostmarkRadio(false)
          setSendgridRadio(false)
          setCustomSmtpRadio(false)
          setFoundercrate(true)
        } else if (data.isActive === 'smtp') {
          setPostmarkRadio(false)
          setSendgridRadio(false)
          setCustomSmtpRadio(true)
          setFoundercrate(false)
        }

        if (data.nylasGoogle !== null) {
          nylasGoogleInitialValues.grantId = data.nylasGoogle.grantId
        }

        if (data.nylasMicrosoft !== null) {
          nylasMicrosoftInitialValues.grantId = data.nylasMicrosoft.grantId
        }

        if (data.isNylasActive === 'nylasGoogle') {
          setNylasGoogleRadio(true)
          setNylasMicrosoftRadio(false)
        } else if (data.isNylasActive === 'nylasMicrosoft') {
          setNylasGoogleRadio(false)
          setNylasMicrosoftRadio(true)
        }
      } else {
        console.log(errors)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getPendingUserList = async () => {
    if (companyId && role === roleValues.OWNER) {
      try {
        const {
          data: {success, data, errors},
        } = await getPendingUsers(companyId)
        if (success) {
          setPendingUsersList(Array.isArray(data) ? data : [])
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  const getUsersList = async () => {
    if (companyId && role === roleValues.OWNER) {
      try {
        const {
          data: {success, data, errors},
        } = await getUserList(companyId)
        if (success) {
          setUserList(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    if (companyId && role && role === roleValues.OWNER) {
      getUsersList()
      getPendingUserList()
    }
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (companyId) {
      getMailInformation()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (key === 6 && billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold') {
      setShowBillingModal(true)
    }
  }, [key]) // eslint-disable-line react-hooks/exhaustive-deps

  // api calling ends

  if (!config.app?.toolbar?.display) {
    return null
  }

  const isPageTitleVisible = showPageTitle(
    config.app?.toolbar?.layout,
    config.app?.pageTitle?.display
  )

  const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
    ? 'btn-light'
    : 'bg-body btn-color-gray-700 btn-active-color-primary'

  return (
    <>
      <div id='kt_app_toolbar ' className={clsx('app-toolbar pt-4 ')}>
        <div
          id='kt_app_toolbar_container'
          className={clsx(
            'app-container d-md-flex flex-md-column align-items-start flex-column overflow-hidden ',
            // 'app-container d-md-flex flex-md-column align-items-start flex-column overflow-hidden position-relative',
            classes.toolbarContainer.join(' '),
            config.app?.toolbar?.containerClass,
            config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
            {
              'container-fluid': config.app?.toolbar?.container === 'fluid',
              'container-xxl': config.app?.toolbar?.container === 'fixed',
            }
          )}
        >
          {/* <PaymentDue /> */}
          <div className='d-md-flex justify-content-md-between w-100 '>
            {isPageTitleVisible && <PageTitleWrapper />}
            <Toolbar />
          </div>

          {location.pathname.includes('settings') && (
            <Tabs
              activeTab={settingsKey}
              className='font-size-13'
              ulClassName='text-muted  dark-border setting-tabs'
              activityClassName='bg-primary'
              onClick={(event, tab) => handleTabClick(event, tab, 'settings')}
            >
              <Tab title={formatMessage({id: 'User'})} className='mr-3 mt-2'>
                <PageTitle
                  breadcrumbs={profileBreadCrumbs}
                  description={formatMessage({id: 'Settings'})}
                >
                  {formatMessage({id: 'Settings'})}
                </PageTitle>
                <div className='mt-5 mb-9'>
                  {/* <User
                  key={key}
                  getApiLoading={getApiLoading}
                  setImgName={setImgName}
                  imgName={imgName}
                  countryOptions={countryOptions}
                /> */}
                </div>
              </Tab>
              <Tab
                // title={formatMessage({ id: 'Company' })}
                // className={`mr-3 mt-2 ${role === roleValues.OWNER || role === roleValues.ADMIN ? '' : 'd-none'
                //   }`}

                title={formatMessage({id: 'Company'})}
                className={`mr-3 mt-2 ${role === roleValues.OWNER ? '' : 'd-none'}`}
              >
                <div className='mt-5 mb-9'>
                  <Company
                    key={key}
                    getCompanyApiLoading={getCompanyApiLoading}
                    setCompanyImgName={setCompanyImgName}
                    companyImgName={companyImgName}
                    setCountryId={setCountryId}
                    countryOptions={countryOptions}
                    stateOptions={stateOptions}
                  />
                </div>
              </Tab>
              {
                <Tab
                  // title={formatMessage({ id: 'Billing' })}
                  // className={`mr-3 mt-2 ${role === roleValues.OWNER ||
                  //   role === roleValues.ADMIN ||
                  //   role === roleValues.BILLING
                  //   ? ''
                  //   : 'd-none'
                  //   }`}

                  title={formatMessage({id: 'Billing'})}
                  className={`mr-3 mt-2 ${role === roleValues.OWNER ? '' : 'd-none'}`}
                >
                  <div className='mt-5 mb-9'>
                    {/* <Billing
                    key={key}
                    billingData={billingData}
                    selected={selected}
                    setSelected={setSelected}
                    onAccessBillingPortal={onAccessBillingPortal}
                  /> */}
                  </div>
                </Tab>
              }

              <Tab
                title={formatMessage({id: 'Team'})}
                className={`mr-3 mt-2 ${role && role !== roleValues.OWNER && 'd-none'}`}
              >
                <div className='mt-5 mb-9'>
                  <Team
                    key={key}
                    userList={userList}
                    pendingUserList={pendingUsersList}
                    getUserList={getUsersList}
                    getPendingUsers={getPendingUserList}
                  />
                </div>
              </Tab>

              <Tab title={formatMessage({id: 'Integration'})} className='mr-3 mt-2'>
                <div className='d-flex'>
                  <div className='mt-5 mb-9 sidebar-investor-db col-md-1' style={{width: '14%'}}>
                    {sidebarOptions.map((sideTabs: any, index: number) => (
                      <VerticalTabs
                        key={index}
                        title={sideTabs}
                        selectedTab={sidebar === index + 1}
                        onClick={() => {
                          setSidebar(index + 1)
                        }}
                      />
                    ))}
                  </div>
                  <div
                    className={
                      `d-flex mt-5 mb-9 px-7 rounded-2 w-100 ` + (mode !== 'dark' ? `bg-white` : ``)
                    }
                    style={{background: '#1e1e2d'}}
                  >
                    {sidebar === 1 ? (
                      <div className='d-flex flex-column w-100'>
                        <div className='d-flex flex-column'>
                          <div className='mt-5 d-flex flex-row '>
                            {emailOptions.map((tabs: any, ind: number) => (
                              <div>
                                <ul className='text-muted text-active-primary d-md-flex flex-row mb-0  d-none align-items-left p-0 cursor-pointer '>
                                  <li
                                    key={ind}
                                    className={
                                      `nav-link text-active-primary py-3 m-0 px-3 d-flex fw-semibold align-items-center` +
                                      (subbar === ind + 1
                                        ? '  border-top-0 border border-bottom-3 border-right-0 border-left-0 border-primary text-primary border-5'
                                        : '')
                                    }
                                    onClick={() => setSubbar(ind + 1)}
                                  >
                                    {tabs}
                                  </li>
                                </ul>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div>
                          {subbar < 2 ? (
                            <div className='my-5'>
                              <EmailIntegration
                                key={1}
                                companyId={companyId}
                                getMailInformation={getMailInformation}
                                customsmtpRadio={customsmtpRadio}
                                foundercrateRadio={foundercrateRadio}
                                sendgridRadio={sendgridRadio}
                                postmarkRadio={postmarkRadio}
                                emailSignature={emailSignature}
                              />
                            </div>
                          ) : (
                            <div className='my-5'>
                              <TransactionalEmailIntegration
                                key={2}
                                companyId={companyId}
                                getMailInformation={getMailInformation}
                                nylasGoogleRadio={nylasGoogleRadio}
                                nylasMicrosoftRadio={nylasMicrosoftRadio}
                                nylasEmailSignature={nylasEmailSignature}
                                connectedAccount={''}
                                setconnectedAccount={setconnectedAccount}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ) : sidebar === 2 ? (
                      <div className='mt-3 w-100'>
                        <div className='d-flex'>
                          <Tabs
                            activeTab={1}
                            className='font-size-13'
                            ulClassName='text-muted dark-border setting-tabs'
                            activityClassName='bg-primary'
                            onClick={(event, tab) => setKey(tab)}
                          >
                            <Tab title={'Calendar Sync'} className='mr-3 mt-2'>
                              <div className='mt-5 w-100'>
                                <NoDataPage width={`0`} commingSoon />
                              </div>
                            </Tab>

                            <Tab title={'Schedule Editor'} className='mr-3 mt-2'>
                              <div className='mt-5 w-100'>
                                <NoDataPage width={`0`} commingSoon />
                              </div>
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                    ) : (
                      <div className='mt-5 d-flex w-100'>
                        <div className='w-100'>
                          <NoDataPage width={`0`} commingSoon />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Tab>
              <Tab
                title={
                  (
                    <div>
                      {mode === 'dark' ? (
                        <img
                          src={toAbsoluteUrl('/media/icons/investor/lock.svg')}
                          alt='lock icon'
                          width={15}
                          className={`me-2 ${
                            billingData?.subscription_items[0].item_price_id.split('-')[0] !==
                            'Gold'
                              ? ''
                              : 'd-none'
                          }`}
                          height={15}
                        />
                      ) : (
                        <img
                          src={toAbsoluteUrl('/media/icons/investor/darkLock.svg')}
                          alt='lock icon'
                          width={15}
                          className={`me-2 ${
                            billingData?.subscription_items[0].item_price_id.split('-')[0] !==
                            'Gold'
                              ? ''
                              : 'd-none'
                          }`}
                          height={15}
                        />
                      )}

                      {formatMessage({id: 'BCC Tracking'})}
                    </div>
                  ) as any
                }
                className='mr-3 mt-2'
              >
                <div className='mt-5 mb-9'>
                  {billingData?.subscription_items[0].item_price_id.split('-')[0] === 'Gold' ? (
                    <BCCTracking key={key} bccEmail={bccEmail} />
                  ) : (
                    <></>
                  )}
                </div>
              </Tab>
              <Tab title={formatMessage({id: 'Locale'})} className='mr-3 mt-2'>
                <div className='mt-5 mb-9'>
                  <Locale key={key} getLocaleApiLoading={getLocaleApiLoading} />
                </div>
              </Tab>
              <Tab title={formatMessage({id: 'Notification Preferences'})} className='mr-3 mt-2'>
                <div className='mt-5 mb-9'>
                  <NotificationPreferences
                    key={key}
                    getPreferences={getPreferences}
                    setGetPreferences={setGetPreferences}
                    getPreferencesApiLoading={getPreferencesApiLoading}
                  />
                </div>
              </Tab>
              <Tab title={formatMessage({id: 'Referral'})} className='mr-3 mt-2'>
                <div className='mt-5 mb-9'>
                  <Referral
                    key={key}
                    paypalId={paypalId}
                    referral={referral}
                    totalEarning={totalEarning}
                    totalReferred={totalReferred}
                    setPaypalId={setPaypalId}
                  />
                </div>
              </Tab>
            </Tabs>
          )}

          {location.pathname.includes('shared-access') ? (
            (!isRkAppReady && isRecordskeeper && companyQueuePosition !== 0) ||
            (companyQueuePosition !== 0 && isRecordskeeper) ? (
              <EarlyAccessInvite />
            ) : planStatus === 'cancelled' && isRecordskeeper ? (
              <ActivateSubscription />
            ) : (
              <>
                <PageTitle
                  breadcrumbs={profileBreadCrumbs}
                  description={formatMessage({id: 'Inbox'})}
                >
                  {formatMessage({id: 'Shared Access'})}
                </PageTitle>
                <div className='mt-3'>
                  <RectangularTabs
                    options={filteredOptions}
                    selectedTab={selectedTab}
                    handleTabChange={handleTabChange}
                  />
                </div>
                <div className='mt-5 mb-9 w-100 '>
                  {selectedTab === 1 && <Inbox />}
                  {selectedTab === 2 && <Calendar />}
                  {selectedTab === 3 && <Contacts />}
                </div>
              </>
            )
          ) : null}

          {(location.pathname.includes('/prospective-investor') ||
            location.pathname.includes('/existing-investor') ||
            location.pathname.includes('/all-investor')) && (
            <div className='d-flex  w-100 justify-content-between prospective-investor-tab flex-column'>
              <div
                className='d-flex gap-3 col-12 mt-3 mt-md-3'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  flexWrap: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {/* <ul
                className='nav nav-stretch nav-line-tabs gap-3  nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2'
                style={{display: 'flex', flexWrap: 'nowrap'}}
              >
                <li className='nav-item mobile-tab font-size-13' style={{border: '2px solid red'}}> */}
                <div
                  className={
                    `col options-container p-0 align-content-center cursor-pointer` +
                    (location.pathname.includes('all-investor') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link
                    className={`nav-link text-active-primary p-4`}
                    to='/investor-database/all-investor'
                  >
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'All Investor'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Access the entire investor database here',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* <li className='nav-item mobile-tab font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('prospective-investor') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link
                    className={`nav-link text-active-primary p-4 `}
                    to='/investor-database/prospective-investor'
                  >
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'Prospective Investor'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Access the shortlisted investors here',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* <li className='nav-item mobile-tab font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('existing-investor') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link
                    className={`nav-link text-active-primary p-4 `}
                    to='/investor-database/existing-investor'
                  >
                    <h1
                      className='m-0 '
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'Existing Investor'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Access all the existing investors here',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li>
              </ul> */}
              </div>
              <div
                className='d-flex gap-md-1 align-items-end gap-2  justify-content-between'
                style={{height: '55px'}}
              >
                <div className='h-75 border bg-white d-flex rounded '>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setInvestorDbFilter(true)}
                  >
                    <KTSVG
                      path={
                        (sort_by_investorDb && sort_order_investorDb) ||
                        selectedContextTargetValue ||
                        selectedStageContextFocusValue ||
                        selectedTargetContextLocationValue ||
                        selectedTargetContextGeographiesValue ||
                        selectedTargetContextInvestorTypeValue
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {(sort_by_investorDb && sort_order_investorDb) ||
                    selectedContextTargetValue ||
                    selectedStageContextFocusValue ||
                    selectedTargetContextLocationValue ||
                    selectedTargetContextGeographiesValue ||
                    selectedTargetContextInvestorTypeValue
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div
                  className='border d-flex align-content-center bg-white rounded m-0 p-0 h-75 w-100 w-md-auto'
                  style={{width: '214px'}}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400 p-5 '
                    name='search'
                    placeholder={formatMessage({id: 'Search Investor'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchValue(e.target.value)}
                    value={searchValue}
                  />
                </div>
                {/* <div className='border d-flex align-items-center'>
                  <button className='btn btn-white h-50 three-dots company-container'>
                    <img src={threeDots} alt='' className='h-25' />
                  </button>
                </div> */}
              </div>
              <Filter setInvestorCrmFilter={setInvestorCrmFilter} />
            </div>
          )}
          {/* Update Investor*/}
          {location.pathname.includes('updates/update') && (
            <div className='d-flex  w-100 justify-content-between prospective-investor-tab  flex-column'>
              <div
                className='d-flex gap-3 col-12 mt-3 mt-md-3'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  // whiteSpace: 'nowrap',
                  flexWrap: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {/* <ul  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2 '
                style={{display: 'flex', flexWrap: 'nowrap'}}
              > */}
                {/* {(role === roleValues.OWNER ||
                  role === roleValues.ADMIN ||
                  role === roleValues.IRM) && ( */}
                {role === roleValues.OWNER && (
                  // <li className='nav-item font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('/updates/update') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/update'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Investor Updates'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Keep investors updated regularly',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('pitch-deck') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/pitch-deck'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Pitch Deck'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Craft impactful decks for your business',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('send-emails') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/send-emails'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Send Emails'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Ensure seamless communication',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {/* <li className='nav-item font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('templates') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link className={`nav-link text-active-primary p-4`} to='/updates/templates'>
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {' '}
                      {formatMessage({id: 'Templates'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Keep templates ready for consistent communication',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* </ul> */}
              </div>
              <div
                className='d-flex gap-md-1 align-items-end gap-2  justify-content-between'
                style={{height: '55px'}}
              >
                <div className='h-75 border bg-white d-flex rounded'>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setInvestorUpdateFilter(true)}
                  >
                    <KTSVG
                      path={
                        investorUpdateStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {investorUpdateStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div
                  className='border d-flex align-content-center bg-white rounded m-0 p-0 h-75 w-100 w-md-auto'
                  style={{width: '214px'}}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400 p-5 '
                    name='search'
                    placeholder={formatMessage({id: 'Search Updates'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchInvestorUpdate(e.target.value)}
                  />
                </div>
              </div>
              <Filter />
            </div>
          )}

          {/* resources*/}
          {/* {location.pathname === '/resources' && (
          <div className='position-relative w-100'>
            <div
              className='position-absolute'
              style={{zIndex: '9', marginRight: '16px', top: '-6px', right: '0'}}
            >
              <div className='d-flex gap-md-4 align-items-center gap-2'>
                <div className='h-75 border bg-white d-flex rounded'>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    style={{paddingTop: '10.5px', paddingBottom: '10.5px'}}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setInvestorUpdateFilter(true)}
                  >
                    <KTSVG
                      path={
                        investorUpdateStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {investorUpdateStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div className='border d-flex align-content-center bg-white rounded  m-0 p-0 h-75'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400'
                    name='search'
                    placeholder={formatMessage({id: 'Search Resources'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchInvestorUpdate(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <Filter />

            <Tabs
              activeTab={resourcesKey}
              className='font-size-13'
              ulClassName='text-muted dark-border setting-tabs'
              activityClassName='bg-primary'
              onClick={(event, tab) => handleTabClick(event, tab, 'resources')}
            >
              <Tab title={formatMessage({id: 'Resources Library'})} className='mt-2'>
                <div className='mt-6 mb-5'>
                  <div className='px-4 py-4 bg-white rounded-3'>
                    <div className='fs-4'>Most Trending Documents</div>
                    <div className='resources-main mt-4'>
                      <ResourceOverview type='resources' />
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab title={formatMessage({id: 'My Downloads'})} className='mt-2'>
                <div className='mt-6 mb-5'>
                  <div className='px-4 py-4 bg-white rounded-3'>
                    <div className='fs-4'>My Downloads</div>
                    <div className='resources-main mt-4'>
                      <ResourceOverview type='downloads' />
                    </div>
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        )} */}

          {/* founder market*/}
          {/* {location.pathname === '/founder-market' && (
          <div className='position-relative w-100'>
            <div
              className='position-absolute'
              style={{zIndex: '9', marginRight: '16px', top: '-6px', right: '0'}}
            >
              <div className='d-flex gap-md-4 align-items-center gap-2'>
                <div className='h-75 border bg-white d-flex rounded'>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    style={{paddingTop: '10.5px', paddingBottom: '10.5px'}}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setInvestorUpdateFilter(true)}
                  >
                    <KTSVG
                      path={
                        investorUpdateStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {investorUpdateStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div className='border d-flex align-content-center bg-white rounded  m-0 p-0 h-75'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400'
                    name='search'
                    placeholder={formatMessage({id: 'Search Deals'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchInvestorUpdate(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <Filter />
            <Tabs
              activeTab={marketDealsKey}
              className='font-size-13'
              ulClassName='text-muted  dark-border setting-tabs'
              activityClassName='bg-primary'
              onClick={(event, tab) => {
                handleTabClick(event, tab, 'founder-market')
              }}
            >
              <Tab title={formatMessage({id: 'Founder Market'})} className='mt-2'>
                <div className='mt-6 mb-5'>
                  <div className='px-4 py-4 bg-white rounded-3'>
                    <div className='fs-4'>Most Trending Deals</div>
                    <div className='founderMarket-main mt-4'>
                      <FounderMarketOverview type='deals' />
                    </div>
                  </div>
                </div>
              </Tab>

              <Tab title={formatMessage({id: 'My Deals'})} className=' mt-2'>
                <div className='mt-6 mb-5'>
                  <div className='px-4 py-4 bg-white rounded-3'>
                    <div className='fs-4'>My Claimed Deals</div>
                    <div className='founderMarket-main mt-4'>
                      <FounderMarketOverview type='claimed Deals' />
                    </div>
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        )} */}

          {/* pitch-deck*/}
          {location.pathname.includes('/pitch-deck') && (
            <div className='d-flex  w-100 justify-content-between prospective-investor-tab flex-column'>
              <div
                className='d-flex gap-3  col-12 mt-3 mt-md-3'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  flexWrap: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {/* <ul
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2 '
                style={{display: 'flex', flexWrap: 'nowrap'}}
              > */}
                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('/updates/update') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/update'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Investor Updates'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Keep investors updated regularly',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('pitch-deck') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/pitch-deck'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Pitch Deck'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Craft impactful decks for your business',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('send-emails') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/send-emails'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Send Emails'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Ensure seamless communication',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {/* <li className='nav-item mobile-tab font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('templates') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link className={`nav-link text-active-primary p-4 `} to='/updates/templates'>
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'Templates'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Keep templates ready for consistent communication',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* </ul> */}
              </div>
              <div
                className='d-flex gap-md-1 align-items-end gap-2  justify-content-between'
                style={{height: '55px'}}
              >
                <div className='h-75 border bg-white d-flex rounded '>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setPitchDeckFilter(true)}
                  >
                    <KTSVG
                      path={
                        pitchDeckStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {pitchDeckStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div
                  className='border d-flex align-content-center bg-white rounded m-0 p-0 h-75  w-100 w-md-auto'
                  style={{width: '214px'}}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400 p-5 '
                    name='search'
                    placeholder={formatMessage({id: 'Search Pitch Deck'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchPitchDeck(e.target.value)}
                  />
                </div>
              </div>
              <Filter />
            </div>
          )}
          {/* send-emails*/}
          {location.pathname.includes('/send-emails') && (
            <div className='d-flex  w-100 justify-content-between prospective-investor-tab flex-column'>
              <div
                className='d-flex  gap-3 col-12 mt-3 mt-md-3'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  flexWrap: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {/* <ul
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2 '
                style={{display: 'flex', flexWrap: 'nowrap'}}
              > */}
                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('/updates/update') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/update'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Investor Updates'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Keep investors updated regularly',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>

                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('pitch-deck') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/pitch-deck'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Pitch Deck'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Craft impactful decks for your business',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('send-emails') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/send-emails'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Send Emails'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Ensure seamless communication',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {/* <li className='nav-item mobile-tab font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('templates') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link className={`nav-link text-active-primary p-4 `} to='/updates/templates'>
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'Templates'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Keep templates ready for consistent communication',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* </ul> */}
              </div>
              <div
                className='d-flex gap-md-1 align-items-end gap-2  justify-content-between'
                style={{height: '55px'}}
              >
                <div className='h-75 border bg-white d-flex rounded '>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setEmailFilter(true)}
                  >
                    <KTSVG
                      path={
                        emailStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {emailStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div
                  className='border d-flex align-content-center bg-white rounded  m-0 p-0 h-75 w-100 w-md-auto'
                  style={{width: '214px'}}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400 p-5 '
                    name='search'
                    placeholder={formatMessage({id: 'Search Send Mail'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchEmail(e.target.value)}
                  />
                </div>
              </div>
              <Filter />
            </div>
          )}
          {/* templates*/}
          {location.pathname.includes('/templates') && (
            <div className='d-flex  w-100 justify-content-between prospective-investor-tab  flex-column'>
              <div
                className='d-flex  gap-3   col-12 mt-3 mt-md-3'
                style={{
                  display: 'flex',
                  overflowX: 'scroll',
                  flexWrap: 'nowrap',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                {/* <ul
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2 '
                style={{display: 'flex', flexWrap: 'nowrap'}}
              > */}
                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('/updates/update') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/update'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Investor Updates'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Keep investors updated regularly',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('pitch-deck') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/pitch-deck'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Pitch Deck'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Craft impactful decks for your business',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {role === roleValues.OWNER && (
                  // <li className='nav-item mobile-tab font-size-13'>
                  <div
                    className={
                      `col options-container  align-content-center cursor-pointer` +
                      (location.pathname.includes('send-emails') && ' selected-option')
                    }
                    style={{
                      width: '192px',
                      flex: '0 0 auto',
                      borderRadius: '8px',
                      padding: '18px, 12px, 18px, 12px',
                      gap: '10px',
                    }}
                  >
                    <Link className={`nav-link text-active-primary p-4 `} to='/updates/send-emails'>
                      <h1
                        className='m-0'
                        style={{
                          fontFamily: 'Poppins',
                          fontWeight: '500',
                          fontSize: '13px',
                          lineHeight: '18px',
                          // color: 'rgba(0, 0, 0, 0.8)',
                        }}
                      >
                        {formatMessage({id: 'Send Emails'})}
                      </h1>
                      <p
                        className='mt-2'
                        style={{
                          whiteSpace: 'normal',
                          // color: 'rgba(56, 57, 64, 0.85)',
                          fontFamily: 'Poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                          lineHeight: '18px',
                        }}
                      >
                        {formatMessage({
                          id: 'Ensure seamless communication',
                        })}
                      </p>
                    </Link>
                  </div>
                  // </li>
                )}

                {/* <li className='nav-item mobile-tab font-size-13'> */}
                <div
                  className={
                    `col options-container  align-content-center cursor-pointer` +
                    (location.pathname.includes('templates') && ' selected-option')
                  }
                  style={{
                    width: '192px',
                    flex: '0 0 auto',
                    borderRadius: '8px',
                    padding: '18px, 12px, 18px, 12px',
                    gap: '10px',
                  }}
                >
                  <Link className={`nav-link text-active-primary p-4 `} to='/updates/templates'>
                    <h1
                      className='m-0'
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        fontSize: '13px',
                        lineHeight: '18px',
                        // color: 'rgba(0, 0, 0, 0.8)',
                      }}
                    >
                      {formatMessage({id: 'Templates'})}
                    </h1>
                    <p
                      className='mt-2'
                      style={{
                        whiteSpace: 'normal',
                        // color: 'rgba(56, 57, 64, 0.85)',
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                      }}
                    >
                      {formatMessage({
                        id: 'Keep templates ready for consistent communication',
                      })}
                    </p>
                  </Link>
                </div>
                {/* </li> */}
                {/* </ul> */}
              </div>
              <div
                className='d-flex gap-md-1 align-items-end gap-2 justify-content-between'
                style={{height: '55px'}}
              >
                <div className='h-75 border bg-white d-flex rounded '>
                  <button
                    className={clsx(
                      'text-clr88 btn btn-sm btn-flex fw-semibold font-size-12',
                      daterangepickerButtonClass
                    )}
                    id='fc-toogle'
                    title='Sort and Filter'
                    data-bs-toggle='tooltip'
                    data-bs-placement='left'
                    data-bs-dismiss='click'
                    data-bs-trigger='hover'
                    onClick={() => setTemplateFilter(true)}
                  >
                    <KTSVG
                      path={
                        templateStatusFilter
                          ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                          : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                      }
                      className='svg-icon-6 svg-icon-muted me-1'
                    />
                    {templateStatusFilter
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </button>
                </div>
                <div
                  className='border d-flex align-content-center bg-white rounded  m-0 p-0 h-75 w-100 w-md-auto'
                  style={{width: '214px'}}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-3 position-absolute ms-3 pt-3'
                  />
                  <input
                    type='text'
                    className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13 font-weight-400 p-5 '
                    name='search'
                    placeholder={formatMessage({id: 'Search Templates'})}
                    data-kt-search-element='input'
                    onChange={(e) => storeSearchTemplate(e.target.value)}
                  />
                </div>
              </div>
              <Filter />
            </div>
          )}

          {/* {location.pathname.includes('/create-investor') && (
          <div className='d-flex overflow-auto h-55px border-bottom space-between w-100 justify-content-between prospective-investor-tab'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both'>
              <li className='nav-item mobile-tab font-size-13'>
                <Link
                  className={
                    `nav-link text-active-primary me-6` +
                    (location.pathname.includes('general') && 'active')
                  }
                  to='/investor-database/create-investor/general'
                >
                  {formatMessage({id: 'General'})}
                </Link>
              </li>
              <li className='nav-item mobile-tab font-size-13'>
                <Link
                  className={
                    `nav-link text-active-primary me-6 ` +
                    (location.pathname.includes('highlight') && 'active')
                  }
                  to='/investor-database/create-investor/highlight'
                >
                  {formatMessage({id: 'Highlights'})}
                </Link>
              </li>
            </ul>
            <div className='d-flex gap-4 align-items-center'>
              <div className='h-75 border bg-white d-flex align-items-center rounded'>
                <button
                  className={clsx('text-clr88 btn btn-sm btn-flex fw-semibold font-size-12', daterangepickerButtonClass)}
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen031.svg'
                    className='svg-icon-6 svg-icon-muted me-1'
                  />
                  {formatMessage({id: 'Filter'})}
                </button>
              </div>
              <div className='border d-flex align-content-center bg-white rounded  m-0 p-0 h-75'>
                 <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 position-absolute ms-3 pt-3'
              />
                <input
                type='text'
                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-13'
                name='search'
                placeholder={formatMessage({id:'Search Investor'})}
                data-kt-search-element='input'
                // value={search}
                // onChange={(e) => setSearch(e.target.value)}
              />
              </div>
              <div className='border d-flex align-items-center'>
                <button className='btn btn-white h-50 three-dots'>
                  <img src={threeDots} alt='' className='h-25' />
                </button>
              </div>
            </div>
          </div>
        )} */}
        </div>
      </div>
    </>
  )
}

const showPageTitle = (appToolbarLayout?: ToolbarType, appPageTitleDisplay?: boolean): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas']
  if (!appToolbarLayout || !appPageTitleDisplay) {
    return false
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout)
}

export {ToolbarWrapper}
